import React from "react";
import { stats } from "../data/content";
export function StatsStrip() {
  return <section aria-label="Lo que incluye en números" className="bg-forest" data-id="element-287" data-mp="ghf7ebxmgv5j">
      <div className="wrap grid grid-cols-2 md:grid-cols-4" data-id="element-288" data-mp="gfc62vr0rfli">
        {stats.map(stat => <div key={stat.label} className="flex flex-col items-center justify-center border border-white/10 bg-forest-soft/50 px-3 py-7 text-center md:py-9" data-id="element-289" data-mp="2k08mglhbb0w">
            <span className="display-title whitespace-nowrap text-[clamp(32px,4vw,52px)] text-gold" data-id="element-290" data-mp="v8o22zgdt6pj">{stat.value}</span>
            <span className="mt-2 text-[11px] font-bold uppercase tracking-[1.5px] text-white" data-id="element-291" data-mp="lgrsar4xns5h">{stat.label}</span>
          </div>)}
      </div>
    </section>;
}